//admin utilityimport { HttpClient, HttpParams } from '@angular/common/http';
// import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
// import { MatPaginator } from '@angular/material/paginator';
// import { MatTableDataSource } from '@angular/material/table';
 import { Router } from '@angular/router';
 import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
 import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
 declare var $;
 import { _ } from 'underscore';
// import { MatTable } from '@angular/material/table';
// import { AdminValidationModalComponent } from '../admin-validation-modal/admin-validation-modal.component';
// import { MatSort, SortDirection } from '@angular/material/sort';
// import {LiveAnnouncer} from '@angular/cdk/a11y';
// import {merge, Observable, of as observableOf} from 'rxjs';
// import {catchError, map, startWith, switchMap} from 'rxjs/operators';
// import {
//   MatDialog,
//   MatDialogRef,
//   MAT_DIALOG_DATA,
// } from '@angular/material/dialog';
// import {
//   MatSnackBar,
//   MatSnackBarHorizontalPosition,
//   MatSnackBarVerticalPosition,
// } from '@angular/material/snack-bar';
// import { ExcelService } from '../excel.service';
// import { IMyDpOptions, IMyDate } from 'mydatepicker';
// import { environment } from '../../../environments/environment';
// import * as moment from 'moment-timezone';
 import { AffilationModel } from 'src/app/shared/models/AffilationModel';
 //import {CustomDatePipe} from 'admin-affiliation-list/custom.datepipe';

// @Component({
//   selector: 'app-admin-affiliation-list',
//   templateUrl: './admin-affiliation-list.component.html',
//   styleUrls: ['./admin-affiliation-list.component.css'],

// })
// export class AdminAffiliationListComponent implements AfterViewInit  {
//    @ViewChild(MatPaginator) paginator: MatPaginator;
//    @ViewChild(MatSort) sort: MatSort;

//   // @ViewChild(MatPaginator) paginator: MatPaginator;
//   // @ViewChild('empTbSort') empTbSort = new MatSort();

//   resultsLength = 0;
//   isLoadingResults = true;
//   isRateLimitReached = false;
//    //providerPaginator: MatPaginator;
//   // @ViewChild(MatTable, { static: true }) table: MatTable<any>;
//   // utilityResult: AffilationModel[];
//   // dataSource: MatTableDataSource<AffilationModel>;
//   displayedColumns: string[] = [
//     'Action',
//     'Status',
//     'AffiliateName',
//     'ContactPerson',
//     'Email',
//     'Phone',
//     'Address',
//     'CreatedBy',
//     'CreatedDate',
//     'ModifiedBy',
//     'ModifiedDate'
    
//   ];
//   selected: string;
 

//   // constructor(
   
//   //   private router: Router,
//   //   private residentialService: ResidentialService,
//   //   public dialog: MatDialog,
//   //   private snackBar: MatSnackBar
//   // ) {}

//   // ngAfterViewInit() {
//   //   this.dataSource.paginator = this.paginator;
    
//   // }
//   // ngOnInit(): void {
//   //   this.GetAllAffilations();
//   // }
//   // GetAllAffilations() {
//   //   this.residentialService
//   //     .GetAllAffilations()
//   //     .subscribe((res: any) => {
//   //       // console.log(response);
//   //       if (res.length > 0) {
//   //         this.utilityResult = res;
//   //         this.dataSource = new MatTableDataSource<AffilationModel>(
//   //           this.utilityResult
//   //         );
//   //         // this.dataSource.paginator = this.providerPaginator;
//   //         // this.dataSource.sort = this.mytable;
//   //       } else {
//   //         const dialogRef = this.dialog.open(AdminAffiliationListComponent, {
//   //           width: '500px',
//   //         });
//   //       }
//   //       // this.utilityResult = response.data.residentailListArr;
//   //       // this.dataSource = new MatTableDataSource<utilityBlock>(this.utilityResult);
//   //       // this.dataSource.paginator = this.providerPaginator;
//   //       // this.dataSource.sort = this.mytable;

//   //     });
//   // }
 
//   // @ViewChild(MatPaginator) paginator: MatPaginator;
//   //@ViewChild(MatSort) sort: MatSort;
//   dataSource: MatTableDataSource<AffilationModel>;



//   constructor(
//     private residentialService: ResidentialService,
//   ) {
//     // Create 100 users
//     this.residentialService
//     .GetAllAffilations()
//     .subscribe((res: any) => {

//       this.dataSource = new MatTableDataSource(res);
      

//     });

//     // Assign the data to the data source for the table to render
  
//   }
//   ngAfterViewInit() {
//     setTimeout(function(){
//       this.dataSource.paginator = this.paginator;
//       this.dataSource.sort = this.sort;

//     },100)
   
//   }

//   //ngAfterViewInit() {
//     //this.dataSource.paginator = this.providerPaginator;
//     //this.dataSource.sort = this.sort;

//   //   merge(this.mytable.sortChange, this.providerPaginator.page)
//   //     .pipe(
//   //       startWith({}),
//   //       switchMap(() => {
          
//   //         return this.exampleDatabase!.getRepoIssues(
//   //           this.mytable.active,
//   //           this.mytable.direction,
//   //           this.providerPaginator.pageIndex,
//   //         ).pipe(catchError(() => observableOf(null)));
//   //       }),
//   //       map(data => {
//   //         // Flip flag to show that loading has finished.
//   //         this.isLoadingResults = false;
//   //         this.isRateLimitReached = data === null;

//   //         if (data === null) {
//   //           return [];
//   //         }

//   //         // Only refresh the result length if there is new data. In case of rate
//   //         // limit errors, we do not want to reset the paginator to zero, as that
//   //         // would prevent users from re-triggering requests.
//   //         this.resultsLength = 50;//data.total_count;
//   //         return data.items;
//   //       }),
//   //     )
//   //     .subscribe(data => (this.data = data));
//   // }
  

//   applyFilter(event: Event) {
//     const filterValue = (event.target as HTMLInputElement).value;
//     this.dataSource.filter = filterValue.trim().toLowerCase();

//     if (this.dataSource.paginator) {
//       this.dataSource.paginator.firstPage();
//     }
//   }


  
// }

import {AfterViewInit, Component, ViewChild,ElementRef} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import { Clipboard } from '@angular/cdk/clipboard';

export interface UserData {
  id: string;
  name: string;
  progress: string;
  fruit: string;
}


/** Constants used to fill up our data base. */
const FRUITS: string[] = [
  'blueberry',
  'lychee',
  'kiwi',
  'mango',
  'peach',
  'lime',
  'pomegranate',
  'pineapple',
];
const NAMES: string[] = [
  'Maia',
  'Asher',
  'Olivia',
  'Atticus',
  'Amelia',
  'Jack',
  'Charlotte',
  'Theodore',
  'Isla',
  'Oliver',
  'Isabella',
  'Jasper',
  'Cora',
  'Levi',
  'Violet',
  'Arthur',
  'Mia',
  'Thomas',
  'Elizabeth',
];

/**
 * @title Data table with sorting, pagination, and filtering.
 */
@Component({
  selector: 'app-admin-affiliation-list',
  templateUrl: './admin-affiliation-list.component.html',
  styleUrls: ['./admin-affiliation-list.component.css'],

})
export class AdminAffiliationListComponent implements AfterViewInit  {
  
  msg;
  title;
  showChangeStatusButtonInPopup = false;
  buttontext = "Ok";
  modalRef: BsModalRef;
  Activate: boolean = false;
  Deactivate: boolean = false;
  Suspend: boolean = false;
  Archive: boolean = false;
  @ViewChild('StatusModel', { static: true }) template: ElementRef;

  displayedColumns: string[] = [
    'select',
        'Action',
        'Status',
        'AffiliateName',
        'ContactPerson',
        'Email',
        'Phone',
     //   'Address',
        'AffiliateLink',
        'CreatedBy',
        'CreatedDateTime',
        // 'ModifiedBy',
        // 'ModifiedDateTime'
        
      ];
      selected: string;

  dataSource: MatTableDataSource<AffilationModel>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  selection = new SelectionModel<AffilationModel>(true, []);

    constructor(
    private residentialService: ResidentialService,
    private router: Router,
    private modalService: BsModalService,
    private clipboard: Clipboard
  ) {
    // Create 100 users
 

    // Assign the data to the data source for the table to render
    this.loadGrid();
  }
  ngAfterViewInit() {

  }

  openModal(template: ElementRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small' })
    );
  }


  Redirect(link)
  {
    this.router.navigate([
      'hg-admin-affiliate-addedit',
      link,
    ]);
  }
  Type;
  ChangeStatus(isWarning = false, Type)
  {

    this.Type = Type == undefined ?  this.Type :  Type;
    Type = this.Type;
    this.showChangeStatusButtonInPopup = false;
    var selected = this.selection.selected;
    if(selected.length == 0)
    {
      this.title = "";
      this.msg = "Please select atleast one promo code to " + Type.toLowerCase() + " Status";
      this.buttontext = "Ok"
      this.openModal(this.template)
      return;
    }
    else if (isWarning)
    {
      this.title = "";
      this.msg = "Are you sure you want to " + Type.toLowerCase() + " status of selected promo code(s)?";
      this.buttontext = "Go Back"
      this.showChangeStatusButtonInPopup = true;
      this.openModal(this.template)
      return;
    }else
    {
      this.modalRef.hide();
    }
 

    var UserID;
    if (!_.isEmpty(sessionStorage.getItem('userObj'))) {
      let result = JSON.parse(sessionStorage.getItem('userObj'));
      if (result.userObj._id) {
        UserID = result.userObj._id;
      } 
    }
   
    var query =[];
    selected.forEach(function (value) {
      
      if(Type == "Active/Inactive")
      {
        query.push({ Type: Type, _id: value._id, Status: value.Status == "Active" ? "Deactivated" : value.Status == "Deactivated" ? "Active" : "Active", CreatedBy: UserID,  })
      }

      if(Type == "Delete")
      {
        query.push({ Type: Type, _id: value._id, Status: "Delete", CreatedBy: UserID,  })
      }

      if(Type == "Archive")
      {
        query.push({ Type: Type, _id: value._id, Status: "Archived", CreatedBy: UserID,  })
      }
      
      if(Type == "Suspend")
      {
        query.push({ Type: Type, _id: value._id, Status:  "Suspended", CreatedBy: UserID,  })
      }

    }); 

    this.residentialService
    .ChangeAffliateStatus(query)
    .subscribe((res: any) => {

      this.title = "";
      this.msg = "Promo code(s) status has been changed successfully";
      this.buttontext = "Ok"
      this.showChangeStatusButtonInPopup = false;
      this.openModal(this.template)
      
      this.router.navigate([
        'hg-admin-affiliate-list',
       
      ]);

    });


  }


  StatusChange(completed: boolean, type: string)
  {
    if(type == "Activate")
    {
      this.Activate = completed;
    }
    if(type == "Deactivate")
    {
      this.Deactivate = completed;
    }
    if(type == "Archive")
    {
      this.Archive = completed;
    }
    if(type == "Suspend")
    {
      this.Suspend = completed;
    }
    this.selection.clear();
    this.loadGrid()
  }
  copyText(v) {
    this.clipboard.copy(v);

    setTimeout(function(){
      $('[data-toggle="tooltip"], .tooltip').tooltip("hide");
    },1000)
  }

  loadGrid()
  {
    this.residentialService
    .GetAllAffilations()
    .subscribe((res: any) => {


      if( res.length != 0 )
      {
        var applyStatus = false;
        var Activatearr = [];
        var mainArray = [];
        if(this.Activate)
        {
          Activatearr = this.filterItems(res,"Active");
          applyStatus = true;

          if(Activatearr.length != 0 )
          {
            if( mainArray.length != 0)
            {
              mainArray = mainArray.concat(Activatearr)
            }else
            {
              mainArray = Activatearr
            }
          }
          // Activatearr.length != 0 && mainArray.length != 0? 
          // mainArray.concat(Activatearr) : mainArray
        }
        var Deactivatearr = [];
        if(this.Deactivate)
        {
          Deactivatearr = this.filterItems(res,"Deactivated");
          applyStatus = true;
          // Deactivatearr.length != 0 ? 
          // mainArray.concat(Deactivatearr) : mainArray
          if(Deactivatearr.length != 0 )
          {
            if( mainArray.length != 0)
            {
              mainArray = mainArray.concat(Deactivatearr)
            }else
            {
              mainArray = Deactivatearr
            }
          }
        }
        var Suspendarr = [];
        if(this.Suspend)
        {
          Suspendarr = this.filterItems(res,"Suspended");
          applyStatus = true;
          // Suspendarr.length != 0 ? 
          // mainArray.concat(Suspendarr) : mainArray
          if(Suspendarr.length != 0 )
          {
            if( mainArray.length != 0)
            {
              mainArray = mainArray.concat(Suspendarr)
            }else
            {
              mainArray = Suspendarr
            }
          }
        }
        var Archivearr = [];
        if(this.Archive)
        {
          Archivearr = this.filterItems(res,"Archived");
          applyStatus = true;
          // Archivearr.length != 0 ? 
          // mainArray.concat(Archivearr) : mainArray
          if(Archivearr.length != 0 )
          {
            if( mainArray.length != 0)
            {
              mainArray = mainArray.concat(Archivearr)
            }else
            {
              mainArray = Archivearr
            }
          }
        }
      }
      if(applyStatus == true)
      {
        //Activatearr.concat(Deactivatearr,Suspendarr,Archivearr);
        this.dataSource = new MatTableDataSource(mainArray);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
      else
      {
        this.dataSource = new MatTableDataSource(res);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }

      setTimeout(function(){
        $('[data-toggle="tooltip"]').tooltip({
          animated: 'fade',
          placement: 'bottom',
          trigger: 'click'
      });
  

      },1000)
      // this.dataSource = new MatTableDataSource(res);
      // this.dataSource.paginator = this.paginator;
      // this.dataSource.sort = this.sort;

    });
  }
  filterItems(arr, query) {
    //return arr.filter((el) => el.Status.toLowerCase().includes(query.toLowerCase()));
    return arr.filter((el) => el.Status.toLowerCase() == query.toLowerCase());
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  checkboxLabel(row?: AffilationModel): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  isAllSelected() {
    var numRows = 0
    const numSelected = this.selection.selected.length;
    if(this.dataSource != undefined)
    {
      numRows = this.dataSource.data.length;
    }
   
    return numSelected === numRows;
  }

}

/** Builds and returns a new User. */
function createNewUser(id: number): UserData {
  const name =
    NAMES[Math.round(Math.random() * (NAMES.length - 1))] +
    ' ' +
    NAMES[Math.round(Math.random() * (NAMES.length - 1))].charAt(0) +
    '.';

  return {
    id: id.toString(),
    name: name,
    progress: Math.round(Math.random() * 100).toString(),
    fruit: FRUITS[Math.round(Math.random() * (FRUITS.length - 1))],
  };
}

import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe extends 
             DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return super.transform(value, "MM/dd/yy h:mm a");
  }
}